module.exports = __webpack_public_path__ + "static/media/relatioBuilding.6fd2ddc3.png";